import axios from 'axios'
const { ADMIN_API_URL = '' } = process.env

const adminRequest = axios.create({
  baseURL: ADMIN_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Add a request interceptor to include auth token
adminRequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default adminRequest
